/**
 * @generated SignedSource<<605712c5c666fd762b99583113abc1a0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ECommerce = "AMAZON" | "API" | "BIG_COMMERCE" | "CODE_CANYON" | "C_CLOUD" | "ETSY" | "MAGENTO" | "MAGENTO1" | "NET_SUITE" | "NONE" | "OPEN_CART" | "PRESTA_SHOP" | "SHOPIFY" | "SHOPWARE" | "WIX" | "WOO_COMMERCE";
export type EmbeddedColorTypes = "CMYK" | "NONE" | "PANTONE";
export type ImageInsertScalingType = "AUTOFIT_SCALE_TO_COVER" | "AUTOFIT_SCALE_TO_FIT" | "SCALE_DOWN";
export type OutputMirrorPrintFiles = "BOTH" | "MIRROR_HORIZONTALLY" | "MIRROR_VERTICALLY" | "NONE";
export type ProductMirrorTypes = "COLORED" | "MIRRORED" | "NONE";
export type ProductProvider = "CASA_DE_LAS_CARCASAS" | "CUSTOM_CAT" | "FAVORITE_GIFT" | "HP" | "INVITION" | "PRINTFUL" | "PRINTFUL_DIRECT" | "UNDEFINED" | "VERSORI" | "ZAKEKE";
export type VectorizeOptionTypeEnum = "NONE" | "RASTER";
import { FragmentRefs } from "relay-runtime";
export type productFragment_modelCompressed$data = {
  readonly additionalCodes: ReadonlyArray<{
    readonly code: string;
    readonly merchantProductName: string;
    readonly salesChannel: {
      readonly ecommerceSettings: {
        readonly ecommerceName: ECommerce;
        readonly remoteUrl: string | null;
      } | null;
    };
    readonly salesChannelID: string;
  }>;
  readonly code: string;
  readonly environment: number;
  readonly id: string;
  readonly largeImageUrl: string | null;
  readonly modelColorMappings: ReadonlyArray<{
    readonly colorID: number;
    readonly merchantCode: string;
    readonly salesChannelID: string;
  }>;
  readonly modelColorsCompressed: string;
  readonly name: string;
  readonly options: ReadonlyArray<{
    readonly colorID: number;
    readonly optionID: number;
    readonly optionsData: {
      readonly backgroundColor: string | null;
      readonly backgroundImageFileObjectID: number | null;
      readonly backgroundImageTempUrl: string | null;
      readonly backgroundImageThumbnailFileObjectID: number | null;
      readonly backgroundImageThumbnailUrl: string | null;
      readonly backgroundImageUrl: string | null;
      readonly backgroundPresetID: number | null;
      readonly backgroundType: number | null;
      readonly depth: number | null;
      readonly edgesColor: string | null;
      readonly includeBorderInPrintFiles: boolean;
      readonly is3DAutoGenEnabled: boolean;
      readonly isResizable: boolean;
      readonly isSplitOutput: boolean;
      readonly keepAspectRatio: boolean;
      readonly lockHeight: boolean;
      readonly lockWidth: boolean;
      readonly maxArea: number | null;
      readonly maxHeight: number | null;
      readonly maxSizeForSide: number | null;
      readonly maxWidth: number | null;
      readonly minArea: number | null;
      readonly minHeight: number | null;
      readonly minSplitHeight: number | null;
      readonly minSplitWidth: number | null;
      readonly minWidth: number | null;
      readonly mirrorType: ProductMirrorTypes;
      readonly presets: ReadonlyArray<{
        readonly height: number;
        readonly name: string | null;
        readonly width: number;
      }>;
      readonly shape: number;
      readonly showHeightSize: boolean;
      readonly showSplitGrid: boolean;
      readonly showWidthSize: boolean;
      readonly startHeight: number | null;
      readonly startSplitColumns: number | null;
      readonly startSplitRows: number | null;
      readonly startWidth: number | null;
      readonly stepHeight: number | null;
      readonly stepWidth: number | null;
    };
    readonly sideID: number | null;
  }>;
  readonly pricingModelID: number;
  readonly printTypes: ReadonlyArray<{
    readonly canAddText: boolean | null;
    readonly canChangeSvgColors: boolean | null;
    readonly canIgnoreDPIWarning: boolean | null;
    readonly canPreviewDesignsPDF: boolean | null;
    readonly canUseImageFilters: boolean | null;
    readonly canUseTextArt: boolean | null;
    readonly defaultFontFamilyID: number | null;
    readonly disableImageColors: boolean | null;
    readonly disableSellerImages: boolean | null;
    readonly disableTextColors: boolean | null;
    readonly disableUserImages: boolean | null;
    readonly dpi: number | null;
    readonly fonts: ReadonlyArray<{
      readonly fontFamilyID: number;
      readonly fontFamilyName: string;
    }>;
    readonly imageColors: ReadonlyArray<{
      readonly colorCode: string;
      readonly isDefault: boolean;
    } | null> | null;
    readonly imageEditingToolSettingsToExclude: string | null;
    readonly name: string;
    readonly outputTypeID: number | null;
    readonly patID: number;
    readonly printTypeID: number;
    readonly printTypeRestrictions: {
      readonly allowAdaptText: boolean | null;
      readonly allowBold: boolean | null;
      readonly allowBottomVerticalAlignment: boolean | null;
      readonly allowCenterAlign: boolean | null;
      readonly allowChangeFontSize: boolean | null;
      readonly allowGradientTextColors: boolean;
      readonly allowImageGalleryTextColors: boolean;
      readonly allowImageUploadTextColors: boolean;
      readonly allowItalic: boolean | null;
      readonly allowJustifyAlign: boolean | null;
      readonly allowLeftAlign: boolean | null;
      readonly allowLetterSpacing: boolean | null;
      readonly allowLineSpacing: boolean | null;
      readonly allowMiddleVerticalAlignment: boolean | null;
      readonly allowRightAlign: boolean | null;
      readonly allowShadows: boolean | null;
      readonly allowTextStroke: boolean | null;
      readonly allowTopVerticalAlignment: boolean | null;
      readonly canAddText: boolean | null;
      readonly canChangeSvgColors: boolean | null;
      readonly canIgnoreDPIWarning: boolean | null;
      readonly canPreviewDesignsPDF: boolean | null;
      readonly canPrintShadows: boolean;
      readonly canStretchImages: boolean | null;
      readonly canStretchTexts: boolean | null;
      readonly canUseImageFilters: boolean | null;
      readonly canUseTextArt: boolean | null;
      readonly convertAiToSvg: boolean | null;
      readonly convertEpsToSvg: boolean | null;
      readonly convertPdfToSvg: boolean | null;
      readonly createVectorizePreview: boolean;
      readonly curvedText: boolean | null;
      readonly defaultColor: string | null;
      readonly defaultFontFamilyID: number | null;
      readonly defaultFontSize: number | null;
      readonly defaultShadowAngle: number | null;
      readonly defaultShadowBlur: number | null;
      readonly defaultShadowColor: string | null;
      readonly defaultShadowDistance: number | null;
      readonly disableImageColors: boolean | null;
      readonly disableSellerImages: boolean | null;
      readonly disableTextColors: boolean | null;
      readonly disableUserImages: boolean | null;
      readonly embeddedColorType: EmbeddedColorTypes;
      readonly embeddedPdf: boolean;
      readonly embeddedUseForRasterAlso: boolean;
      readonly enableVectorize: boolean;
      readonly fixedFontSize: number | null;
      readonly fontSizeList: ReadonlyArray<number> | null;
      readonly fonts: ReadonlyArray<{
        readonly fontFamilyID: number;
        readonly fontFamilyName: string;
      }> | null;
      readonly imageColors: ReadonlyArray<{
        readonly colorCode: string;
        readonly isDefault: boolean;
      }> | null;
      readonly imageEditingToolSettingsToExclude: string | null;
      readonly imageInsertScalingCliparts: ImageInsertScalingType | null;
      readonly imageInsertScalingUpload: ImageInsertScalingType | null;
      readonly isLargeFileEnabled: boolean;
      readonly maxFontSize: number | null;
      readonly maxLetterSpacing: number | null;
      readonly maxLineSpacing: number | null;
      readonly maxNrImages: number | null;
      readonly maxNrTextElements: number | null;
      readonly maxShadowAngle: number | null;
      readonly maxShadowBlur: number | null;
      readonly maxShadowDistance: number | null;
      readonly maxTextStrokeWidth: number | null;
      readonly minFontSize: number | null;
      readonly minLetterSpacing: number | null;
      readonly minLineSpacing: number | null;
      readonly minShadowAngle: number | null;
      readonly minShadowBlur: number | null;
      readonly minShadowDistance: number | null;
      readonly minTextStrokeWidth: number | null;
      readonly outputMirror: OutputMirrorPrintFiles | null;
      readonly shadowColors: ReadonlyArray<{
        readonly colorCode: string;
        readonly isDefault: boolean;
      }> | null;
      readonly showDuplicateButton: boolean | null;
      readonly showFlipButtons: boolean | null;
      readonly showImageProvider: boolean | null;
      readonly showLayerButtons: boolean | null;
      readonly showVectorizeModal: boolean;
      readonly textBox: boolean | null;
      readonly textColors: ReadonlyArray<{
        readonly colorCode: string;
        readonly isDefault: boolean;
      }> | null;
      readonly uploadRestrictions: {
        readonly isAiAllowed: boolean | null;
        readonly isEpsAllowed: boolean | null;
        readonly isFacebookAllowed: boolean | null;
        readonly isInstagramAllowed: boolean | null;
        readonly isJpgAllowed: boolean | null;
        readonly isPdfAllowed: boolean | null;
        readonly isPdfWithRasterAllowed: boolean | null;
        readonly isPngAllowed: boolean | null;
        readonly isSvgAllowed: boolean | null;
        readonly isUserImageAllowed: boolean | null;
        readonly resizeLargePdf: boolean | null;
      } | null;
      readonly uppercase: boolean | null;
      readonly useCustomFonts: boolean | null;
      readonly useImagesFixedSize: boolean | null;
      readonly vectorizeOption: VectorizeOptionTypeEnum;
    } | null;
    readonly printTypeRestrictionsID: number | null;
    readonly showDuplicateButton: boolean | null;
    readonly showFlipButtons: boolean | null;
    readonly showImageProvider: boolean | null;
    readonly showLayerButtons: boolean | null;
    readonly textColors: ReadonlyArray<{
      readonly colorCode: string;
      readonly isDefault: boolean;
    } | null> | null;
    readonly uploadRestrictions: {
      readonly isEpsAllowed: boolean | null;
      readonly isFacebookAllowed: boolean | null;
      readonly isInstagramAllowed: boolean | null;
      readonly isJpgAllowed: boolean | null;
      readonly isPdfAllowed: boolean | null;
      readonly isPdfWithRasterAllowed: boolean | null;
      readonly isPngAllowed: boolean | null;
      readonly isSvgAllowed: boolean | null;
      readonly isUserImageAllowed: boolean | null;
    } | null;
    readonly useCustomFonts: boolean | null;
    readonly useImagesFixedSize: boolean | null;
  }>;
  readonly provider: ProductProvider;
  readonly providerCode: string | null;
  readonly salesChannel: {
    readonly ecommerceSettings: {
      readonly ecommerceName: ECommerce;
    } | null;
  };
  readonly salesChannelID: string;
  readonly sceneConfig: {
    readonly general: {
      readonly arAnchor: string | null;
      readonly arEnabled: boolean | null;
    } | null;
  } | null;
  readonly smallImageUrl: string;
  readonly sourceProductTemplateID: number | null;
  readonly statusID: number;
  readonly " $fragmentType": "productFragment_modelCompressed";
};
export type productFragment_modelCompressed$key = {
  readonly " $data"?: productFragment_modelCompressed$data;
  readonly " $fragmentSpreads": FragmentRefs<"productFragment_modelCompressed">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "salesChannelID",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ecommerceName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "colorID",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "disableTextColors",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "disableImageColors",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "disableSellerImages",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "disableUserImages",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "useImagesFixedSize",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canAddText",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "useCustomFonts",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canChangeSvgColors",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canUseImageFilters",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canIgnoreDPIWarning",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canPreviewDesignsPDF",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showLayerButtons",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showDuplicateButton",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showFlipButtons",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageEditingToolSettingsToExclude",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showImageProvider",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canUseTextArt",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "defaultFontFamilyID",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "PrintTypeFont",
  "kind": "LinkedField",
  "name": "fonts",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fontFamilyID",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fontFamilyName",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v24 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "colorCode",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isDefault",
    "storageKey": null
  }
],
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "RestrictionColor",
  "kind": "LinkedField",
  "name": "textColors",
  "plural": true,
  "selections": (v24/*: any*/),
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "RestrictionColor",
  "kind": "LinkedField",
  "name": "imageColors",
  "plural": true,
  "selections": (v24/*: any*/),
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isUserImageAllowed",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isJpgAllowed",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPngAllowed",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSvgAllowed",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPdfAllowed",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPdfWithRasterAllowed",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isEpsAllowed",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isFacebookAllowed",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isInstagramAllowed",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "productFragment_modelCompressed",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "statusID",
      "storageKey": null
    },
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "providerCode",
      "storageKey": null
    },
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sourceProductTemplateID",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SalesChannel",
      "kind": "LinkedField",
      "name": "salesChannel",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EcommerceSettings",
          "kind": "LinkedField",
          "name": "ecommerceSettings",
          "plural": false,
          "selections": [
            (v3/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductCode",
      "kind": "LinkedField",
      "name": "additionalCodes",
      "plural": true,
      "selections": [
        (v1/*: any*/),
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "merchantProductName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SalesChannel",
          "kind": "LinkedField",
          "name": "salesChannel",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EcommerceSettings",
              "kind": "LinkedField",
              "name": "ecommerceSettings",
              "plural": false,
              "selections": [
                (v3/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "remoteUrl",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ModelColorMapping",
      "kind": "LinkedField",
      "name": "modelColorMappings",
      "plural": true,
      "selections": [
        (v4/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "merchantCode",
          "storageKey": null
        },
        (v2/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pricingModelID",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "largeImageUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "smallImageUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "provider",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "environment",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ModelOption",
      "kind": "LinkedField",
      "name": "options",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "optionID",
          "storageKey": null
        },
        (v4/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sideID",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ModelOptionsData",
          "kind": "LinkedField",
          "name": "optionsData",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isResizable",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "is3DAutoGenEnabled",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isSplitOutput",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startWidth",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "minWidth",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "maxWidth",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "stepWidth",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startHeight",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "minHeight",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "maxHeight",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "stepHeight",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "maxSizeForSide",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "minArea",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "maxArea",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "depth",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "keepAspectRatio",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lockWidth",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lockHeight",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "showWidthSize",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "showHeightSize",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "showSplitGrid",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "mirrorType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "edgesColor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "minSplitWidth",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "minSplitHeight",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startSplitColumns",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startSplitRows",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "includeBorderInPrintFiles",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "backgroundType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "backgroundColor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "backgroundPresetID",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "backgroundImageTempUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "backgroundImageFileObjectID",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "backgroundImageThumbnailFileObjectID",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "backgroundImageUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "backgroundImageThumbnailUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ModelOptionDataPresetData",
              "kind": "LinkedField",
              "name": "presets",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "width",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "height",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "shape",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SceneConfig",
      "kind": "LinkedField",
      "name": "sceneConfig",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SceneGeneralConfig",
          "kind": "LinkedField",
          "name": "general",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "arEnabled",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "arAnchor",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ModelPrintType",
      "kind": "LinkedField",
      "name": "printTypes",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "printTypeID",
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dpi",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "patID",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "outputTypeID",
          "storageKey": null
        },
        (v5/*: any*/),
        (v6/*: any*/),
        (v7/*: any*/),
        (v8/*: any*/),
        (v9/*: any*/),
        (v10/*: any*/),
        (v11/*: any*/),
        (v12/*: any*/),
        (v13/*: any*/),
        (v14/*: any*/),
        (v15/*: any*/),
        (v16/*: any*/),
        (v17/*: any*/),
        (v18/*: any*/),
        (v19/*: any*/),
        (v20/*: any*/),
        (v21/*: any*/),
        (v22/*: any*/),
        (v23/*: any*/),
        (v25/*: any*/),
        (v26/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "UploadRestriction",
          "kind": "LinkedField",
          "name": "uploadRestrictions",
          "plural": false,
          "selections": [
            (v27/*: any*/),
            (v28/*: any*/),
            (v29/*: any*/),
            (v30/*: any*/),
            (v31/*: any*/),
            (v32/*: any*/),
            (v33/*: any*/),
            (v34/*: any*/),
            (v35/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "printTypeRestrictionsID",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PartPrintTypeRestriction",
          "kind": "LinkedField",
          "name": "printTypeRestrictions",
          "plural": false,
          "selections": [
            (v5/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "allowGradientTextColors",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "allowImageUploadTextColors",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "allowImageGalleryTextColors",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "enableVectorize",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "showVectorizeModal",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "vectorizeOption",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createVectorizePreview",
              "storageKey": null
            },
            (v6/*: any*/),
            (v7/*: any*/),
            (v8/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "embeddedColorType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "embeddedUseForRasterAlso",
              "storageKey": null
            },
            (v9/*: any*/),
            (v10/*: any*/),
            (v11/*: any*/),
            (v12/*: any*/),
            (v13/*: any*/),
            (v14/*: any*/),
            (v15/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canStretchImages",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canStretchTexts",
              "storageKey": null
            },
            (v16/*: any*/),
            (v17/*: any*/),
            (v18/*: any*/),
            (v19/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "imageInsertScalingUpload",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "imageInsertScalingCliparts",
              "storageKey": null
            },
            (v20/*: any*/),
            (v21/*: any*/),
            (v22/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "convertPdfToSvg",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "convertAiToSvg",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "convertEpsToSvg",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "curvedText",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "allowBold",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "allowItalic",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "uppercase",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "maxNrTextElements",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "defaultColor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "allowLeftAlign",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "allowCenterAlign",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "allowJustifyAlign",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "allowRightAlign",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "maxNrImages",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "textBox",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "allowLetterSpacing",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "minLetterSpacing",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "maxLetterSpacing",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "allowLineSpacing",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "minLineSpacing",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "maxLineSpacing",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "allowAdaptText",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "allowChangeFontSize",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "minFontSize",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "maxFontSize",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "fixedFontSize",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "fontSizeList",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "defaultFontSize",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "allowTopVerticalAlignment",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "allowMiddleVerticalAlignment",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "allowBottomVerticalAlignment",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "allowShadows",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canPrintShadows",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "defaultShadowColor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "defaultShadowBlur",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "defaultShadowDistance",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "defaultShadowAngle",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "minShadowBlur",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "maxShadowBlur",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "minShadowDistance",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "maxShadowDistance",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "minShadowAngle",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "maxShadowAngle",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "outputMirror",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isLargeFileEnabled",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "allowTextStroke",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "minTextStrokeWidth",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "maxTextStrokeWidth",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "embeddedPdf",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RestrictionColor",
              "kind": "LinkedField",
              "name": "shadowColors",
              "plural": true,
              "selections": (v24/*: any*/),
              "storageKey": null
            },
            (v23/*: any*/),
            (v25/*: any*/),
            (v26/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "UploadRestriction",
              "kind": "LinkedField",
              "name": "uploadRestrictions",
              "plural": false,
              "selections": [
                (v27/*: any*/),
                (v28/*: any*/),
                (v29/*: any*/),
                (v30/*: any*/),
                (v31/*: any*/),
                (v32/*: any*/),
                (v33/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isAiAllowed",
                  "storageKey": null
                },
                (v34/*: any*/),
                (v35/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "resizeLargePdf",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "modelColorsCompressed",
      "storageKey": null
    }
  ],
  "type": "Model",
  "abstractKey": null
};
})();

(node as any).hash = "cfd1971c9211aa5be3ab6b73eaa3796b";

export default node;
